import {Product} from '@hconnect/apiclient'
import React from 'react'
import {UseFormReturn} from 'react-hook-form'

import {Option} from '../../../common/AutoSelectDropdown'
import {BrandingForCountry} from '../../../components/UserInformation/utils/utils'
import {RoleAssignment} from '../../../modules/ManageUsers.selectors'
import {WidgetUserCreationFormData} from '../WidgetUserCreation.form'
import {DataScopeOption} from '../WidgetUserCreation.types'

import {WidgetBrandingInput} from './WidgetBrandingInput'
import {WidgetBusinessLineInput} from './WidgetBusinessLineInput'
import {WidgetCompanyInput} from './WidgetCompanyInput'
import {WidgetCountryInput} from './WidgetCountryInput'
import {WidgetDispatchPhoneKeyInput} from './WidgetDispatchPhoneKeyInput'
import {WidgetEmailInput} from './WidgetEmailInput'
import {WidgetMarketInput} from './WidgetMarketInput'
import {WidgetMobileNumberInput} from './WidgetMobileNumberInput'
import {WidgetNameInput} from './WidgetNameInput'
import {WidgetOrgUnitInput} from './WidgetOrgUnitInput'

interface WidgetUserFormFieldsProps {
  formMethods: UseFormReturn<WidgetUserCreationFormData>
  selectedProducts?: Product[]
  cscCountries: string[] | undefined
  brandings: BrandingForCountry[]
  loadingAvailableCountries: boolean
  marketSelectValues: Option[]
  primaryOrgUnitsMarketsSelectValues: Option[]
  cscBusinessLines: string[] | undefined
  selectedCountry: string
  cscData: RoleAssignment[] | undefined
  selectedOrgUnit: DataScopeOption | undefined
  setSelectedOrgUnit: (value: DataScopeOption | undefined) => void
  selectedBusinessLine: string
}

export const WidgetUserFormFields = ({
  formMethods,
  selectedProducts,
  cscCountries,
  brandings,
  loadingAvailableCountries,
  marketSelectValues,
  primaryOrgUnitsMarketsSelectValues,
  cscBusinessLines,
  selectedCountry,
  cscData,
  selectedOrgUnit,
  setSelectedOrgUnit,
  selectedBusinessLine
}: WidgetUserFormFieldsProps) => {
  return (
    <>
      <WidgetNameInput formMethods={formMethods} />
      <WidgetEmailInput formMethods={formMethods} selectedProducts={selectedProducts} />
      <WidgetMobileNumberInput formMethods={formMethods} selectedProducts={selectedProducts} />
      {cscCountries && cscCountries?.length > 1 && (
        <WidgetCountryInput formMethods={formMethods} countryCodes={cscCountries} />
      )}
      <WidgetCompanyInput formMethods={formMethods} />
      <WidgetBrandingInput
        formMethods={formMethods}
        brandings={brandings}
        isLoadingBrandings={loadingAvailableCountries}
      />
      <WidgetMarketInput
        formMethods={formMethods}
        marketSelectValues={marketSelectValues}
        isLoadingMarkets={loadingAvailableCountries}
      />
      <WidgetDispatchPhoneKeyInput
        formMethods={formMethods}
        primaryOrgUnitsMarketsSelectValues={primaryOrgUnitsMarketsSelectValues}
      />
      {cscBusinessLines && cscBusinessLines?.length > 0 && (
        <WidgetBusinessLineInput
          formMethods={formMethods}
          disabled={cscCountries && cscCountries?.length > 0 ? !selectedCountry : false}
          cscBusinessLines={cscBusinessLines}
        />
      )}
      <WidgetOrgUnitInput
        formMethods={formMethods}
        cscData={cscData}
        selectedOrgUnit={selectedOrgUnit}
        setSelectedOrgUnit={setSelectedOrgUnit}
        disabled={cscBusinessLines && cscBusinessLines?.length > 0 ? !selectedBusinessLine : false}
      />
    </>
  )
}
